<template>
    <div class="content-body">
        <LanguageSelector />
        <section id="basic-datatable">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-content">
                        <div class="card-header">
                            <h5 class="card-title">{{ $t('Manage Landlords')}}</h5>
                            <div class="heading-elements">
                                <ul class="list-inline mb-0">
                                    <li v-if="!phoneFilter" class="spacing">
                                        <button class="btn btn-primary" @click="findByPhoneModal()">
                                            {{ $t('Find by Phone')}}
                                        </button>
                                    </li>
                                    <li v-else class="spacing">
                                        <button class="btn btn-danger" @click="getLandlords()">
                                            {{ $t('Remove Phone Filter')}}
                                        </button>
                                    </li>
                                    <li class="spacing">
                                        <div class="has-icon-left">
                                            <select class="form-control" v-model="genderFilter" @change="filterByData()">
                                                <option selected>{{$t('All Genders...')}}</option>
                                                <option value="Male">{{$t('Male')}}</option>
                                                <option value="Female">{{$t('Female')}}</option>
                                                <option value="Private">{{ $t('Private')}}</option>
                                            </select>
                                            <div class="form-control-position">
                                                <em class="bx bx-user font-medium-1"></em>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="spacing">
                                        <div class="has-icon-left">
                                            <select class="form-control" v-model="countryFilter" @change="filterByData()">
                                                <option selected>{{$t('All Countries...')}}</option>
                                                <option v-for="(country, index) in usersCountries" :value="country" :key="index">{{ countryName(country) }}</option>
                                            </select>
                                            <div class="form-control-position">
                                                <em class="bx bx-map font-medium-1"></em>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="has-icon-left">
                                            <input type="text" class="form-control" @keyup="searchInTable()" v-model="searchInputText" :placeholder="$t('Search...')"/>
                                            <div class="form-control-position">
                                                <em class="bx bx-search font-medium-1"></em>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                            <div class="card-body card-dashboard">
                                <div class="text-center">
                                    <div class="spinner-border text-primary" role="status" v-if="loadingData" style="opacity: .6">
                                        <span class="sr-only">{{$t('Loading...')}}</span>
                                    </div>
                                </div>
                                <div class="text-center mt-1" v-if="!landlords.length && !loadingData">
                                    <p>{{$t('No Users Found...')}}</p>
                                </div>
                                <div class="table-responsive" v-if="landlords.length">
                                    <table class="table zero-configuration " :aria-label="$t('manage_landlords_arial_labelLandlord_list')">
                                        <thead>
                                            <tr>
                                                <th>{{$t('Name')}}</th>
                                                <th>{{$t('Status')}}</th>
                                                <th>{{$t('Gender')}}</th>
                                                <th>{{$t('City')}}</th>
                                                <th>{{$t('Date of Birth')}}</th>
                                                <th>{{$t('Created At')}}</th>
                                                <th>{{$t('Country')}}</th>
                                                <th>{{$t('Contract')}}</th>
                                                <th>{{$t('Contacts')}}</th>
                                                <th>{{$t('House')}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(landlord, index) in landlords" :key="index">
                                                <td class="landlordName" v-if="landlord.name">
                                                    <router-link class="text-bold-500" :to="{name: 'SingleUserPage', params: {uuid: landlord.uid} }">{{ landlord.name }}</router-link>
                                                    <br>
                                                    <a href="#" @click="editLandlordModal(landlord.uid)" style="margin-top: 5px;"><em class="bx bx-edit-alt"></em> {{$t('Edit')}}</a>
                                                </td>
                                                <td v-else>
                                                    -
                                                    <br>
                                                    <a href="#" @click="editLandlordModal(landlord.uid)" style="margin-top: 5px;"><em class="bx bx-edit-alt"></em> {{$t('Edit')}}</a>
                                                </td>
                                                <td v-if="landlord.status == 'banned'">
                                                    <em class="bx bxs-circle danger font-small-1 mr-50"></em><span>{{$t('Banned')}}</span>
                                                </td>
                                                <td v-else>
                                                    <em class="bx bxs-circle success font-small-1 mr-50"></em><span>{{$t('Active')}}</span>
                                                </td>
                                                <td v-if="landlord.gender" class="capitalize">{{ landlord.gender }}</td>
                                                <td v-else>-</td>
                                                <td v-if="landlord.address.city">{{ landlord.address.city }}</td>
                                                <td v-else>-</td>
                                                <td v-if="landlord.dob">{{ landlord.dob.split('T')[0] }}</td>
                                                <td v-else>-</td>
                                                <td>{{ landlord.createdAt.split('T')[0] }}</td>
                                                <td v-if="landlord.currentCountry">{{ countryName(landlord.currentCountry) }}</td>
                                                <td v-else>-</td>
                                                <td>-</td>
                                                <td>
                                                    <span v-if="landlord.phoneNumber">{{ landlord.phoneNumber }}</span>
                                                    <span v-else>-</span>
                                                    <br>
                                                    <span v-if="landlord.email">{{ landlord.email }}</span>
                                                    <span v-else>-</span>
                                                </td>
                                                <td>-</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Find by Phone Modal -->
        <div class="modal fade text-left" id="find-by-phone-modal" tabindex="-1" role="dialog" aria-labelledby="create-modal-title" aria-hidden="true">
        <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title">{{$t('Insert Phone Number')}}</h3>
                <button type="button" class="close rounded-pill" data-dismiss="modal" aria-label="Close">
                <em class="bx bx-x"></em>
                </button>
            </div>
            <div class="modal-body">
                <PhoneNumberInput :phoneNumber="phoneNumberTarget" :onPhoneNumberChange="onWhatsappPhoneNumberChange" />
                <div class="text-center">
                    <button type="button" class="btn btn-primary" @click="findByPhone()">
                        <em class="bx bx-check d-block d-sm-none"></em>
                        <span class="d-none d-sm-block">{{$t('Search')}}</span>
                    </button>
                </div>
            </div>
            </div>
        </div>
        </div>

        <!-- Edit Landlord Modal -->
        <div class="modal fade text-left" id="edit-landlord-modal" tabindex="-1" role="dialog" aria-labelledby="create-modal-title" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title" id="create-modal-title">{{$t('Edit Landlord')}}</h3>
                <button type="button" class="close rounded-pill" data-dismiss="modal" aria-label="Close">
                <em class="bx bx-x"></em>
                </button>
            </div>
            <div class="modal-body">
                <Alert :text="deleteUserErrorText" type="danger" dismissable="false" v-if="deleteUserErrorText != ''" />
                <Alert :text="banUserErrorText" type="danger" dismissable="false" v-if="banUserErrorText != ''" />
                <form action="#">
                    <div class="form-group row">
                        <div class="col-md-6 col-sm-12">
                            <label for="">{{$t('Name')}}</label>
                            <input type="text" class="form-control" v-model="nameEdit">
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <label for="">{{$t('Date of Birth')}}</label>
                            <div class="form-group position-relative has-icon-left">
                                <input type="text" class="form-control" :placeholder="$t('Select Date')" id="dob-input" v-model="dobEdit">
                                <div class="form-control-position">
                                    <em class='bx bx-calendar'></em>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-md-6 col-sm-12">
                            <label for="">{{$t('Current Country')}}</label>
                            <select class="form-control" v-model="currentCountryEdit">
                                <option v-for="(aC, index) in activeCountries" :key="index" :value="aC.toLowerCase()">{{ countryName(aC) }}</option>
                            </select>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <label for="">{{$t('Gender')}}</label>
                            <select class="form-control" v-model="genderEdit">
                                <option value="male">{{$t('Male')}}</option>
                                <option value="female">{{$t('Female')}}</option>
                                <option value="private">{{$t('Private')}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-md-6 col-sm-12">
                            <label for="">{{$t('Street')}}</label>
                            <input type="text" class="form-control" v-model="addressStreetEdit">
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <label for="">{{$t('Additional')}}</label>
                            <input type="text" class="form-control" v-model="addressAdditionalEdit">
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-md-6 col-sm-12">
                            <label for="">{{$t('City')}}</label>
                            <input type="text" class="form-control" v-model="addressCityEdit">
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <label for="">{{$t('ZIP')}}</label>
                            <input type="text" class="form-control" v-model="addressZipEdit">
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-md-12 col-sm-12">
                            <label for="">{{$t('Description')}}</label>
                            <textarea class="form-control" rows="6" v-model="addressDescriptionEdit"></textarea>
                        </div>
                    </div>
                    <p class="text-muted">
                        {{$t('Last edited by:')}} <strong>{{ lastEditedBy }}</strong>
                    </p>
                </form>
                <div class="text-left">
                    <button class="btn btn-danger" @click="banUser(targetEdit.uid)" v-if="targetEdit.status != 'banned'">
                        {{$t('Ban User')}}
                    </button>
                    <button class="btn btn-success" @click="unbanUser(targetEdit.uid)" v-else>
                        {{$t('Unban User')}}
                    </button>
                    <button class="btn btn-danger" v-if="(targetEdit.contracts && !targetEdit.contracts.length || !targetEdit.contracts) && (targetEdit.contractProposals && !targetEdit.contractProposals.length || !targetEdit.contractProposals) && (targetEdit.properties && !targetEdit.properties.length || !targetEdit.properties)" @click="deleteLandlord(targetEdit.uid)">
                        {{$t('Delete User')}}
                    </button>
                    <button class="btn btn-danger" v-if="targetEdit.contracts && targetEdit.contracts.length" @click="deleteData(targetEdit.contracts, 'contracts')">
                        {{$t('Delete Contracts')}}
                    </button>
                    <button class="btn btn-danger" v-if="(targetEdit.contracts && !targetEdit.contracts.length || !targetEdit.contracts) && targetEdit.contractProposals && targetEdit.contractProposals.length" @click="deleteData(targetEdit.contractProposals, 'proposals')">
                        {{$t('Delete Proposals')}}
                    </button>
                    <button class="btn btn-danger" v-if="(targetEdit.contractProposals && !targetEdit.contractProposals.length || !targetEdit.contractProposals) && targetEdit.properties && targetEdit.properties.length" @click="deleteData(targetEdit.properties, 'properties')">
                        {{$t('Delete Properties')}}
                    </button>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-light-secondary" data-dismiss="modal">
                    <em class="bx bx-x d-block d-sm-none"></em>
                    <span class="d-none d-sm-block">{{$t('Close')}}</span>
                </button>
                <button type="button" class="btn btn-primary ml-1" @click="editLandlord(targetEdit.uid)">
                    <em class="bx bx-check d-block d-sm-none"></em>
                    <span class="d-none d-sm-block">{{$t('Save Changes')}}</span>
                </button>
            </div>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
  import '@/app-assets/js/scripts/extensions/ext-component-block-ui.js'
  import { getCountryName } from '@/app-assets/js/get-countries.js'
  import Alert from "@/components/Alerts";
  import PhoneNumberInput from "@/components/PhoneNumberInput/PhoneNumberInput";


    export default {
        data() {
            return {
                landlords: [],
                usersCountries: [],
                countryFilter: 'All Countries...',
                genderFilter: 'All Genders...',
                activeCountries: [],
                loadingData: true,
                searchInputText: '',
                targetEdit: [],
                nameEdit: '',
                addressAdditionalEdit: '',
                addressStreetEdit: '',
                addressCityEdit: '',
                addressZipEdit: '',
                addressDescriptionEdit: '',
                currentCountryEdit: '',
                genderEdit: '',
                dobEdit: '',
                lastEditedBy: '-',
                phoneNumberObj: null,
                phoneNumberTarget: '',
                phoneFilter: false,
                deleteUserErrorText: "",
                banUserErrorText: ""
            }
        },

        components: {
            Alert,
            PhoneNumberInput
        },

        methods: {

            deleteData(data, type){
                var promiseURI = [];
                var block_ele = $("#edit-landlord-modal .modal-content")
                $(block_ele).block({
                    message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
                    overlayCSS: {
                        backgroundColor: "#fff",
                        opacity: 0.8,
                        cursor: 'wait'
                    },
                    css: {
                        border: 0,
                        padding: 0,
                        backgroundColor: 'transparent'
                    }
                });
                switch (type){
                    case 'contracts': {
                        data.map(x => {
                            promiseURI.push(this.$apiCall.delete(`/v1/contracts/contract/${x}`));
                        })
                        break;
                    }
                    case 'proposals': {
                        data.map(x => {
                            promiseURI.push(this.$apiCall.delete(`/v1/contracts/proposals/${x}?deleteInvites=true`));
                        })
                        break;
                    }
                    case 'properties': {
                        data.map(x => {
                            promiseURI.push(this.$apiCall.delete(`/v1/properties/${x}`));
                        })
                        break;
                    }
                }



                Promise.all(promiseURI)
                .then(response => {
                    this.editLandlordModal(this.targetEdit.uid, 'delete')
                    // $("#edit-landlord-modal").modal('hide')
                    // this.landlords = []
                    // this.getLandlords()
                })
                .catch(error => {
                    $(block_ele).unblock()
                })
            },

            editLandlordModal(uid, from = 'table'){
                this.deleteUserErrorText = ""
                if(from == 'table'){
                    $.blockUI({
                        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
                        overlayCSS: {
                            backgroundColor: "#fff",
                            opacity: 0.8,
                            cursor: 'wait'
                        },
                        css: {
                            border: 0,
                            padding: 0,
                            backgroundColor: 'transparent'
                        }
                    })
                } else{
                    var block_ele = $("#edit-landlord-modal .modal-content")    
                }
                let self = this
                this.$apiCall.get(`/v1/users/${uid}`)
                .then(response => {
                    console.log(response);
                    $.unblockUI()
                    self.targetEdit = response.data
                    self.nameEdit = self.targetEdit.name
                    self.addressAdditionalEdit = self.targetEdit.address.additional
                    self.addressStreetEdit = self.targetEdit.address.street
                    self.addressCityEdit = self.targetEdit.address.city
                    self.addressZipEdit = self.targetEdit.address.zip
                    self.addressDescriptionEdit = self.targetEdit.address.description
                    self.currentCountryEdit = ((self.targetEdit.currentCountry) ? self.targetEdit.currentCountry : 'lb')
                    self.genderEdit = ((self.targetEdit.gender) ? self.targetEdit.gender : 'male')
                    self.lastEditedBy = (self.targetEdit.lastEditedBy.name) ? self.targetEdit.lastEditedBy.name : '-'
                    let dob = ''
                    if(self.targetEdit.dob){
                        dob = self.targetEdit.dob.split('T')[0].split('-')
                        dob = `${dob[1]}/${dob[2]}/${dob[0]}`
                    }
                    self.dobEdit = dob

                    //DOB Input
                    const pD = $("#dob-input").pickadate({
                        format: 'mm/dd/yyyy',
                        selectYears: 200,
                        selectMonths: true
                    });

                    if(from == 'table'){
                        $("#edit-landlord-modal").modal()
                    } else{
                        $(block_ele).unblock()
                    }
                })
            },

            onWhatsappPhoneNumberChange(value) {
      this.phoneNumberTarget = value;
    },
            editLandlord(uid){
                let self = this
                var block_ele = $("#edit-landlord-modal .modal-content")
                this.deleteUserErrorText = ""
                $(block_ele).block({
                    message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
                    overlayCSS: {
                        backgroundColor: "#fff",
                        opacity: 0.8,
                        cursor: 'wait'
                    },
                    css: {
                        border: 0,
                        padding: 0,
                        backgroundColor: 'transparent'
                    }
                });
                let newDob = $("#dob-input").val().split('/')
                newDob = `${newDob[2]}-${newDob[0]}-${newDob[1]}T00:00Z`
                this.$apiCall.patch(`/v1/users/${uid}`, {
                    "name": self.nameEdit,
                    "address": {
                        "street": self.addressStreetEdit,
                        "additional": self.addressAdditionalEdit,
                        "city": self.addressCityEdit,
                        "zip": self.addressZipEdit,
                        "description": self.addressDescriptionEdit
                    },
                    "dob": newDob,
                    "currentCountry": self.currentCountryEdit,
                    "gender": self.genderEdit
                })
                .then(response => {
                    $(block_ele).unblock()
                    $("#edit-landlord-modal").modal('hide')
                    self.landlords = []
                    self.getLandlords()
                })
                .catch(error => {
                    $.unblockUI()
                    $(block_ele).unblock()
                    this.deleteUserErrorText = `$t('Ops') ${error.response.data.message}`
                })
            },

            filterByData() {
            let self = this;
            self.landlords = [];
            self.loadingData = true;
            let filterData = {};
            
            if (self.countryFilter != "All Countries...") {
                filterData.country = self.countryFilter;
            }
             if (self.genderFilter != "All Genders...") {
                filterData.gender = self.genderFilter.toLowerCase();
            }
           
            if ( filterData.gender || filterData.country) {
                self.filterApiCall(filterData)
            }
            else {
                self.landlords = []
                self.usersCountries = [];
                self.getLandlords();
            }
        },
        
                filterApiCall(data) {            
            let self = this;
            self.$apiCall
                .get(`/v1/users?type=landlord&`, { params: data })
                .then(response => {
                    self.loadingData = false;
                    self.landlords = response.data.data;
                    self.initDataTable();
                })
        },

            banUser(uid){
                let self = this
                this.banUserErrorText = "";
                $.blockUI({
                    message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
                    overlayCSS: {
                        backgroundColor: "#fff",
                        opacity: 0.8,
                        cursor: 'wait'
                    },
                    css: {
                        border: 0,
                        padding: 0,
                        backgroundColor: 'transparent'
                    }
                })
                this.$apiCall.post(`/v1/users/${uid}/ban`)
                .then(response => {
                    $.unblockUI()
                    $("#edit-landlord-modal").modal('hide')
                    self.landlords = []
                    self.getLandlords()
                })
                .catch(error => {
                    $.unblockUI()
                    this.banUserErrorText = `$t('Ops') ${error.response.data.message}`
                })
            },

            unbanUser(uid){
                let self = this
                $.blockUI({
                    message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
                    overlayCSS: {
                        backgroundColor: "#fff",
                        opacity: 0.8,
                        cursor: 'wait'
                    },
                    css: {
                        border: 0,
                        padding: 0,
                        backgroundColor: 'transparent'
                    }
                })
                this.$apiCall.post(`/v1/users/${uid}/unban`)
                .then(response => {
                    $.unblockUI()
                    $("#edit-landlord-modal").modal('hide')
                    self.landlords = []
                    self.getLandlords()
                })
            },

            deleteLandlord(uid){
                let self = this
                this.deleteUserErrorText = ""
                $.blockUI({
                    message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
                    overlayCSS: {
                        backgroundColor: "#fff",
                        opacity: 0.8,
                        cursor: 'wait'
                    },
                    css: {
                        border: 0,
                        padding: 0,
                        backgroundColor: 'transparent'
                    }
                })
                this.$apiCall.delete(`/v1/users/${uid}`)
                .then(response => {
                    $.unblockUI()
                    $("#edit-landlord-modal").modal('hide')
                    self.landlords = []
                    self.getLandlords()
                })
                .catch(error => {
                    $.unblockUI()
                    this.deleteUserErrorText = `$t('Ops') ${error.response.data.message}`
                })
            },

            initDataTable(){
                let self = this
                setTimeout(function(){
                    $('.zero-configuration').DataTable({
                        // "scrollX": true,
                        "bLengthChange": false,
                        "bFilter": false,
                        "order": []
                    });
                }, 100)
            },

            searchInTable(){
                var value = this.searchInputText.toLowerCase();
                $(".zero-configuration > tbody tr").filter(function() {
                    $(this).toggle($(this).find('.landlordName').text().toLowerCase().indexOf(value) > -1)
                });
            },

            getLandlords(){
                let self = this
                self.phoneFilter = false
                self.loadingData = true
                self.landlords = []
                this.$apiCall.get('/v1/users?type=landlord')
                .then(response => {
                    self.loadingData = false
                    self.landlords = response.data.data
                    response.data.data.forEach(function(element){
                        if(!self.usersCountries.includes(element.currentCountry) && element.currentCountry){
                            self.usersCountries.push(element.currentCountry)
                        }
                    })
                    self.initDataTable()
                })
            },

            countryName(element){
                if(element){
                    return getCountryName(element.toUpperCase())
                }
            },

            filterByCountry(country){
                let self = this
                if(country != 'All Countries...'){
                    self.loadingData = true
                    self.landlords = []
                    self.$apiCall.get(`/v1/users?type=landlord&country=${country}`)
                    .then(response => {
                        self.loadingData = false
                        self.landlords = response.data.data
                        self.initDataTable()
                    })
                } else{
                    self.landlords = []
                    self.usersCountries = []
                    self.getLandlords()
                }
            },

            filterByGender(gender){
                let self = this
                if(gender != 'All Genders...'){
                    self.loadingData = true
                    self.landlords = []
                    self.$apiCall.get(`/v1/users?type=landlord&gender=${gender.toLowerCase()}`)
                    .then(response => {
                        self.loadingData = false
                        self.landlords = response.data.data
                        self.initDataTable()
                    })
                } else{
                    self.landlords = []
                    self.getLandlords()
                }
            },

            getActiveCountries(){
                const countries = localStorage.getItem('activeCountries');
              
                this.activeCountries = (countries && countries != '') ? countries.split(',') : ["LB", "JO"];
            },

            findByPhoneModal(){
                $("#find-by-phone-modal").modal()
            },

            initTelInput(){
                let input = document.querySelector("#phoneNumber")
                this.phoneNumberObj = intlTelInput(input)
            },

            findByPhone(){
                let self = this
                let countryData = this.phoneNumberTarget
                let pN = '%2B' + countryData;
                self.landlords = []
                self.loadingData = true
                self.phoneFilter = true
                $("#find-by-phone-modal").modal('hide')
                this.$apiCall.get(`/v1/users/phone/${pN}`)
                .then(response =>  {
                    if(response.data.type === 'landlord'){
                        self.landlords.push(response.data)
                    } else{
                        self.landlords = []
                    }
                    self.phoneNumberTarget = ''
                    self.loadingData = false
                    self.initDataTable()
                })
                .catch(error => {
                    self.phoneNumberTarget = ''
                    self.loadingData = false
                    self.initDataTable()
                })
            }
        },

       

        mounted(){
            this.getLandlords()
            this.getActiveCountries()
            // this.initTelInput()
            if (navigator.appVersion.indexOf("Chrome/") != -1) {
                $("li > .btn.btn-primary").addClass("mt-chrome")
            } else {
                $("li > .btn.btn-primary").addClass("mt-firefox")
            }
        }
    }
</script>

<style scoped>
    .zero-configuration td {
        white-space: nowrap;
    }
    .spacing{
        margin-right: 1em;
    }
</style>